export const DIMENSIONS = {
  bottle: {
    width: 60,
    height: 200,
    cornerRadius: 5,
    rimWidth: 3,
    rimHeight: 10
  },
  slot: {
    width: 80,
    height: 80,
    cornerRadius: 10,
    borderWidth: 2
  },
  layer: {
    height: 40
  },
  button: {
    width: 100,
    height: 50,
    cornerRadius: 8,
    fontSize: 16
  },
  header: {
    height: 60,
    titleSize: 28,
    infoSize: 14
  },
  hud: {
    height: 45,
    padding: 8,
    fontSize: 14
  },
  toast: {
    maxWidth: 300,
    padding: 15,
    borderRadius: 8,
    fontSize: 14
  },
  particle: {
    size: 8,
    count: 20
  }
};

// Mobile responsive dimensions (scaled down for small screens)
export const getResponsiveDimensions = (screenWidth: number, screenHeight: number) => {
  // Determine if mobile based on screen size
  const isMobile = screenWidth < 600 || screenHeight < 700;
  const isSmallMobile = screenWidth < 400 || screenHeight < 600;
  
  // Scale factors
  const scale = isSmallMobile ? 0.7 : isMobile ? 0.8 : 1;
  const headerScale = isSmallMobile ? 0.65 : isMobile ? 0.75 : 1;
  const headerInfoScale = isSmallMobile ? 0.75 : isMobile ? 0.85 : 1;
  const hudScale = isSmallMobile ? 0.55 : isMobile ? 0.65 : 1;
  
  return {
    bottle: {
      width: Math.floor(DIMENSIONS.bottle.width * scale),
      height: Math.floor(DIMENSIONS.bottle.height * scale),
      cornerRadius: Math.max(3, Math.floor(DIMENSIONS.bottle.cornerRadius * scale)),
      rimWidth: Math.max(2, Math.floor(DIMENSIONS.bottle.rimWidth * scale)),
      rimHeight: Math.max(5, Math.floor(DIMENSIONS.bottle.rimHeight * scale))
    },
    slot: {
      width: Math.floor(DIMENSIONS.slot.width * scale),
      height: Math.floor(DIMENSIONS.slot.height * scale),
      cornerRadius: Math.max(5, Math.floor(DIMENSIONS.slot.cornerRadius * scale)),
      borderWidth: Math.max(1, Math.floor(DIMENSIONS.slot.borderWidth * scale))
    },
    layer: {
      height: Math.floor(DIMENSIONS.layer.height * scale)
    },
    button: {
      width: Math.floor(DIMENSIONS.button.width * scale),
      height: Math.floor(DIMENSIONS.button.height * scale),
      cornerRadius: Math.max(4, Math.floor(DIMENSIONS.button.cornerRadius * scale)),
      fontSize: Math.max(12, Math.floor(DIMENSIONS.button.fontSize * scale))
    },
    header: {
      height: Math.floor(DIMENSIONS.header.height * headerScale),
      titleSize: Math.max(16, Math.floor(DIMENSIONS.header.titleSize * headerScale)),
      infoSize: Math.max(10, Math.floor(DIMENSIONS.header.infoSize * headerInfoScale))
    },
    hud: {
      height: Math.floor(DIMENSIONS.hud.height * hudScale),
      padding: Math.max(6, Math.floor(DIMENSIONS.hud.padding * scale)),
      fontSize: Math.max(12, Math.floor(DIMENSIONS.hud.fontSize * hudScale))
    },
    scale,
    isMobile,
    isSmallMobile
  };
};

export const SPACING = {
  bottle: 15,
  slot: 15,
  button: 10,
  padding: 20,
  smallPadding: 5
};

export const ANIMATION = {
  duration: {
    fast: 150,
    normal: 300,
    slow: 500,
    verySlow: 1000
  },
  easing: {
    easeOutQuad: (t: number) => t * (2 - t),
    easeOutCubic: (t: number) => (--t) * t * t + 1,
    easeOutElastic: (t: number) => {
      const c4 = (2 * Math.PI) / 3;
      return t === 0 ? 0 : t === 1 ? 1 : Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c4) + 1;
    },
    easeInOutBack: (t: number) => {
      const c1 = 1.70158;
      const c2 = c1 * 1.525;
      return t < 0.5
        ? (Math.pow(2 * t, 2) * ((c2 + 1) * 2 * t - c2)) / 2
        : (Math.pow(2 * t - 2, 2) * ((c2 + 1) * (t * 2 - 2) + c2) + 2) / 2;
    }
  }
};

export const Z_INDEX = {
  background: 0,
  particles: 10,
  slots: 20,
  bottles: 30,
  ui: 40,
  overlays: 50,
  toasts: 60
};

export const OPACITY = {
  normal: 1,
  disabled: 0.5,
  ghost: 0.3,
  highlight: 0.8
};

export const SCALE = {
  normal: 1,
  small: 0.9,
  large: 1.1
};
